/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import styled from 'styled-components'

const StyledImageContent = styled.div`
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
`

interface ImageWidgetProps {
  url: string
  scaling: string
  alignment?: string
}

const StyledImageWidget = styled(StyledImageContent)<ImageWidgetProps>`
  background-image: url('${({ url }) => url}');
  background-size: ${({ scaling }) => scaling};
  background-position: ${({ alignment }) => alignment};
`
export default StyledImageWidget
